import { useState } from 'react';
import { ReactComponent as UnplannedIcon } from './icons/unplanned.svg';
import { OUTAGE_BANNER_CONFIG } from './outage-banner-config';
import './OutageBanner.scss';

const { isActive, title, message, sessionStorageKey } = OUTAGE_BANNER_CONFIG;

export default function OutageBanner() {
    const [dismissed, setDismissed] = useState<boolean>(() => {
        try {
            return sessionStorage.getItem(sessionStorageKey) === 'true';
        } catch {
            return false;
        }
    });

    if (!isActive || dismissed) return null;

    const handleDismiss = () => {
        try {
            sessionStorage.setItem(sessionStorageKey, 'true');
        } catch {
            // sessionStorage unavailable (e.g., private browsing on some browsers) — still hide in-memory
        }
        setDismissed(true);
    };

    return (
        <div className="outage-banner" role="status" aria-live="polite">
            <UnplannedIcon className="outage-banner__icon" aria-hidden="true" />
            <div className="outage-banner__content">
                <div className="outage-banner__title">{title}</div>
                <div className="outage-banner__message">{message}</div>
            </div>
            <button
                type="button"
                className="outage-banner__close"
                onClick={handleDismiss}
                aria-label="Dismiss outage notification"
            >
                <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M2 2 L14 14 M14 2 L2 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
            </button>
        </div>
    );
}
